/* ==========================================================================
   PUREGANIC — Nutrition facts drawer
   Vanilla, scoped, no libraries. Opens a side drawer (desktop) / bottom-sheet
   (mobile) from a collapsible PDP row. ESC + backdrop + close button close it;
   body scroll is locked while open; focus returns to the trigger on close.
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.pgNutriReady === 'true') return;
    root.dataset.pgNutriReady = 'true';

    var openBtn = root.querySelector('[data-pg-nutri-open]');
    var drawer = root.querySelector('[data-pg-nutri-drawer]');
    var panel = root.querySelector('.pg-nutri__panel');
    var closeEls = Array.prototype.slice.call(root.querySelectorAll('[data-pg-nutri-close]'));
    if (!openBtn || !drawer) return;

    // Portal the drawer to <body> so position:fixed is never trapped by a
    // transformed/overflow-clipped ancestor in the product column.
    if (drawer.parentNode !== document.body) document.body.appendChild(drawer);

    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      // next frame so the CSS transition runs from the off-screen state
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
      });
      document.documentElement.classList.add('pg-nutri-open');
      openBtn.setAttribute('aria-expanded', 'true');
      if (panel) panel.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('pg-nutri-open');
      openBtn.setAttribute('aria-expanded', 'false');
      // wait for the slide-out transition before hiding
      var done = function () {
        drawer.hidden = true;
        panel && panel.removeEventListener('transitionend', done);
      };
      if (panel) panel.addEventListener('transitionend', done);
      else drawer.hidden = true;
      // fallback in case transitionend doesn't fire
      setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 400);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    // openBtn is the accordion <summary>: stop the native expand, open the drawer instead.
    openBtn.addEventListener('click', function (e) { e.preventDefault(); open(); });
    closeEls.forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-pg-nutri]').forEach(init);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  // Re-init when the theme editor reloads the product section
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
